"use client";
import { ReactNode } from "react";
import CategoryCard from "../../Cards/CategoryCard/CategoryCard";
import "./categoryCardList.scss";
import {
  ICategoryCardResponseModel,
  IComponentBoxesResponseModel,
  TOptionalType,
} from "../../../core/models";
import TitleWithDescription from "../../TitleWithDescription/TitleWithDescription";

interface CategoryCardListProps {
  props?: TOptionalType<IComponentBoxesResponseModel>;
}

const CategoryCardList = ({ props }: CategoryCardListProps) => {
  return (
    <div className="row category-list">
      <TitleWithDescription></TitleWithDescription>

      {props?.boxes.map(
        (card: ICategoryCardResponseModel, index: number): ReactNode => {
          return (
            <div className="col-6" key={index}>
              <CategoryCard card={card}></CategoryCard>
            </div>
          );
        }
      )}
    </div>
  );
};

export default CategoryCardList;
